import "core-js/stable";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "filepond-polyfill";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap-icons/font/bootstrap-icons.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

serviceWorker.unregister();
